import { Injectable } from '@angular/core';
import { HashLocationStrategy } from '@angular/common';

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
  override prepareExternalUrl(internal: string): string {
    console.log('preparing external decode internal', super.prepareExternalUrl(decodeURIComponent(internal)));
    if (internal && (internal.indexOf("content.dropboxapi.com") >= 0 || internal.indexOf("www.googleapis.com") >= 0) && internal.indexOf("upload%3Furl%3Dhttps") >= 0)
      return window.location.search + super.prepareExternalUrl(decodeURIComponent(internal));
    else
      return window.location.search + super.prepareExternalUrl(internal);
  }
}
